import { signInFromJoinLink } from '../guards.js';

// The join link in a Supercharger free member's texts (wb-notify-service's
// {join_link}, a web-only Branch link) opens here with her one-time login
// token - see signInFromJoinLink.
export const path = '/glp-won/:gameId/join';
export const component = 'GlpWonJoin';
export const thunk =
  ({ ctx } = {}) =>
  (dispatch, getState) =>
    signInFromJoinLink(dispatch, getState, ctx);
